import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import GisContainer from './GisContainer';
import GISExpands from './../selections/expands/GISExpands';
import { SetActivo, BorrarPoli, MasPoly, SetDistance, SendData, InserBarrio, ToggleMarkerHeat, DatosChecks, BorrarDato, saveMapToDataUrl } from './GisScript';
import './Style.css';
import { api_base } from './../../../constants/services/api';

var api = `${api_base}dash/filter`;
var funcionPoligonos;
// const CerrarTal = () => {
//     // console.log('cerrar');
//     Cerrar();
// }
export default class GIS_SCREEN extends Component {

    state = {
        arrayFiltros: {},
        dataResultGis: {},
        dataLocation: {},
        filtro: {},
        openSnackBar: false,
        messegeSnackBar: 'Note archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archivedNote archived',
        typeSnackBar: 'error'
    }

    getDataGis = () => {
        var data = JSON.stringify({
            selection1: this.state.arrayFiltros,

        });

        fetch(
            `${api}/mapa`,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: data,
            }
        ).then((response) => response.json())
            .then((data_token) => {
                this.setState({ dataResultGis: data_token }, () => SendData(this.state.dataResultGis.location));

            }).catch(err => {
                this.handleOpenSnackBar("error en la conexión", "error")
                console.log("entre la puto error", err)
            })

    }
    filtrosGis = (seleccion) => {
        this.setState({ arrayFiltros: seleccion });
    }
    Cuadrante = (value, click) => {
        // CuadranteData = value;
    }

    handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ openSnackBar: false });
    };
    handleOpenSnackBar = (messege, type) => {
        this.setState({ openSnackBar: true, messegeSnackBar: messege, typeSnackBar: type });
    };

    filterReset = () => {
        this.setState({ arrayFiltros: JSON.parse(JSON.stringify({})) })
    }

    othersTools = (value, id, group) => {
        if (isNaN(value)) {
            switch (value) {
                case 'Navegar': SetActivo(0); break;//InserBarrio("Villas de San Nicolas") ; break;
                case 'Informacion': this.getDataGis(); break;
                case 'Borrar': this.filterReset(); BorrarDato(); break;
                case 'Calor': ToggleMarkerHeat(); break;
                case 'Vista': saveMapToDataUrl(); break;
                case 'Seguridad': SetActivo(10); break;
                case 'Deportivo': SetActivo(11); break;
                case 'Salud': SetActivo(12); break;
                case 'Comercio': SetActivo(13); break;
                case 'Transporte': InserBarrio("comuna_id", 1);; break;
                default: break;
            }
        } else {
            if (value == null) {
            } else {
                SetDistance(value);
            }

        }

    }

    GetComuna = (arregloComunas) => {
        // console.log(arregloComunas);
        // Comunas = arregloComunas;
        DatosChecks(arregloComunas);
    }
    polygonTools = (value) => {
        funcionPoligonos = value;
        if (isNaN(value)) {
            switch (value) {
                case 'Navegar': SetActivo(0); break;//InserBarrio("Villas de San Nicolas") ; break;
                case 'Polígono': SetActivo(2); break;
                case 'Borrar': BorrarPoli(); break;
                case 'Otras': MasPoly(); break;
                case 'Punto': SetActivo(8); break;
                default: break;
            }
        } else {
            if (value == null) {
            } else {
                SetDistance(value);
            }

        }
    }
    componentDidMount() {
        fetch(`${api_base}/api/dash/list/location`).then(Response => Response.json()).then(dataLocation => {
            this.setState({ dataLocation })
        });
    }
    selectSelect = (val) => {
        let value = JSON.parse(val.value);
        // console.log('tales', val);
        InserBarrio(value.object, value.id);
    }
    render() {
        return (
            <Grid container className="gis-select">
                <Grid className="Filter" item xs={12} sm={5} md={4} lg={3} >
                    <GISExpands tipoSeleccion={'GIS'}
                        polygonTools={this.polygonTools}
                        filter={this.filtrosGis}
                        Comuna={this.GetComuna}
                        dataLocation={this.state.dataLocation}
                        Cuadrante={this.Cuadrante}
                        otherTools={this.othersTools}
                        dataResult={this.state.arrayFiltros}
                        onSelect={this.selectSelect}
                    />
                </Grid>
                <Grid item xs={12} sm={7} md={8} lg={9} >
                    <GisContainer
                        poligonos={funcionPoligonos}
                        data={this.state.arrayFiltros}
                        selcet={this.state.filtro}
                    />
                </Grid>
            </Grid>
        )
    }
}
